var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#calendar_svg__a)",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.666 5.333V8M9.333 5.333V8M12.667 6.667h-1.334c-2.514 0-3.77 0-4.552.78C6 8.23 6 9.487 6 12v1.333c0 2.515 0 3.772.781 4.553.781.78 2.038.78 4.552.78h1.334c2.514 0 3.77 0 4.552-.78.781-.781.781-2.038.781-4.553V12c0-2.514 0-3.771-.781-4.552s-2.038-.781-4.552-.781M6 10.667h12"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar_svg__a",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00274C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgCalendar;